<template>
  <v-form ref="form">
    <v-select
      id="axis-select"
      v-model="filter.responsaveis"
      item-text="nome"
      item-value="responsavelId"
      :items="responsaveis"
      :label="name || 'Responsáveis'"
      :placeholder="name || 'Responsáveis'"
      multiple
      :rules="rules"
      outlined
      hide-details="auto"
      :disabled="disabled"
    >
      <div
        style="display: flex; padding: 0 10px; cursor: pointer"
        slot="prepend-item"
        ripple
        @click="toggle"
      >
        <div style="margin-right: 32px">
          <v-icon
            :color="filter.responsaveis.length > 0 ? 'indigo darken-4' : ''"
            >{{ icon }}</v-icon
          >
        </div>
        <div>Todos</div>
      </div>
      <v-divider slot="prepend-item" class="mt-2" />

      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay">{{ item.nome }} &nbsp;</span>
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ filter.responsaveis.length - maxDisplay }} responsaveis)</span
        >
      </template>

      <template slot="no-data"> Nenhum Responsável retornado </template>
    </v-select>
  </v-form>
</template>

<script>
import { territorioResponsavelAPI } from "@/modules/gestao-territorios/API/territorioResponsavelAPI";

export default {
  name: "TerritorioResponsavelCombobox",
  props: ["filter", "name", "rules", "disabled"],
  mounted() {
    this.loadAxis();
  },
  methods: {
    loadAxis() {
      territorioResponsavelAPI
        .list()
        .then((resp) => {
          this.responsaveis = resp.data;
        })
        .catch();
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.responsaveis = [];
        } else {
          this.filter.responsaveis = this.responsaveis.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.responsaveis.length === this.responsaveis.length;
    },
    likesSome() {
      return this.filter.responsaveis.length > 0 && !this.responsaveis;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      responsaveis: [],
    };
  },
};
</script>
